import TextInputField from "../../FormFields/TextInputField/TextInputField";
import { GeorgiaAnnualSignatureFields } from "./AnnualReportStateForms/GeorgiaAnnualReportFields";
import { EinSignatureField } from "./EinTaxFields";
import { isAnnualSelected } from "./PurchaseFormHelpers";

export default function SignatureField(props: {
    errors: any;
    touched: any;
    values: any;
    selectedProducts: any;
    setFieldValue: any;
}) {

    const { errors, touched, values, selectedProducts, setFieldValue } = props;

    const annualSelected = isAnnualSelected(selectedProducts);
    const pastDueAnnualSelected = selectedProducts['pastDueAnnualReport'] ? true : false;

    const einSelected = selectedProducts["einTaxId"] ? true : false;

    if (annualSelected || pastDueAnnualSelected) {
        return (
            <GeorgiaAnnualSignatureFields
                errors={errors}
                touched={touched}
                values={values}
                selectedProducts={selectedProducts}
                onChange={einSelected ? (e: any) => {
                    setFieldValue("annualReport.electronicSignature", e.target.value);
                    setTimeout(() => {
                        setFieldValue("einTaxInfo.digitalSignature", e.target.value);
                    }, 100)
                }
                    : undefined
                }
            />
        )
    }

    if (einSelected) {
        return (
            <EinSignatureField
                errors={errors}
                touched={touched}
            />
        )
    }


    return (
        <TextInputField
            fieldName={"electronicSignature"}
            fieldLabel={"Client Agreement & Signature"}
            errors={errors}
            touched={touched}
            required={true}
            placeholder={"Electronic Signature"}
            customClass={"signature-font"}
        />
    )

}